import { getRegisterFunction } from '../../utils/register.js';
import { OneUxListElement } from './OneUxListElement.js';
export const register = getRegisterFunction(OneUxListElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-list': OneUxListElement;
    "list-0d20d3bd598e73e45c4377705d8ec8c6": OneUxListElement;
  }
}